import { createSlice } from '@reduxjs/toolkit';
import { initState } from './init.state';
import {
  AuditUsersAsync,
  AuditCommunitiesAsync,
  AuditSitesAsync,
} from './async.thunks';

export const AuditSlice = createSlice({
  name: 'audit',
  initialState: initState,
  reducers: {
    ClearUsersAudit: (state) => {
      state.users = initState.users;
    },
    ClearCommunitiesAudit: (state) => {
      state.communities = initState.communities;
    },
    ClearSitesAudit: (state) => {
      state.sites = initState.sites;
    },
    ClearAllAudit: () => initState,
  },
  extraReducers: (builder) => {
    // Users Audit
    builder.addCase(AuditUsersAsync.pending, (state) => {
      state.users.loading = true;
      state.users.error = null;
    });
    builder.addCase(AuditUsersAsync.fulfilled, (state, action) => {
      state.users.loading = false;
      state.users.results = action.payload.results;
      state.users.summary = action.payload.summary;
      state.users.lastAuditAt = action.payload.lastAuditAt;
    });
    builder.addCase(AuditUsersAsync.rejected, (state, action) => {
      state.users.loading = false;
      state.users.error = action.error.message || 'Failed to audit users';
    });

    // Communities Audit
    builder.addCase(AuditCommunitiesAsync.pending, (state) => {
      state.communities.loading = true;
      state.communities.error = null;
    });
    builder.addCase(AuditCommunitiesAsync.fulfilled, (state, action) => {
      state.communities.loading = false;
      state.communities.results = action.payload.results;
      state.communities.lastAuditAt = action.payload.lastAuditAt;
    });
    builder.addCase(AuditCommunitiesAsync.rejected, (state, action) => {
      state.communities.loading = false;
      state.communities.error = action.error.message || 'Failed to audit communities';
    });

    // Sites Audit
    builder.addCase(AuditSitesAsync.pending, (state) => {
      state.sites.loading = true;
      state.sites.error = null;
    });
    builder.addCase(AuditSitesAsync.fulfilled, (state, action) => {
      state.sites.loading = false;
      state.sites.results = action.payload.results;
      state.sites.lastAuditAt = action.payload.lastAuditAt;
    });
    builder.addCase(AuditSitesAsync.rejected, (state, action) => {
      state.sites.loading = false;
      state.sites.error = action.error.message || 'Failed to audit sites';
    });
  },
});

export const {
  ClearUsersAudit,
  ClearCommunitiesAudit,
  ClearSitesAudit,
  ClearAllAudit,
} = AuditSlice.actions;
export { AuditUsersAsync, AuditCommunitiesAsync, AuditSitesAsync } from './async.thunks';
export default AuditSlice.reducer;
